import React, { useEffect, useState } from "react";
import axios from "../../../../api/axios";
import Swal from "sweetalert2";

const ApproveFromPolice = (props) => {
  const [laws, setLaws] = useState([]);
  const [selectedLawId, setSelectedLawId] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSending, setIsSending] = useState(false); // ✅ loader state

  const storedToken = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const token = "Bearer " + storedToken.replace(/"/g, "");
  const headers = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  // ✅ Fetch laws once
  useEffect(() => {
    axios
      .get("/api/reports/laws", { headers })
      .then((res) => setLaws(res.data))
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: "Nuk mund të ngarkohen ligjet!",
          timer: 2500,
          showConfirmButton: true,
        });
      });
  }, []);

  // ✅ Send request
  const send = () => {
    if (!selectedLawId) {
      setErrorMessage("Ju lutemi zgjidhni një ligj!");
      return;
    }

    setIsSending(true); // ✅ start loading

    const body = {
      reportId: props.id,
      policeId: userId,
      isApprovedByPolice: true,
      lawId: parseInt(selectedLawId, 10),
    };

    axios
      .post("/api/reports/policeResponse", body, { headers })
      .then(() => {
        Swal.fire({
          icon: "success",
          text: "Përgjigjja u regjistrua me sukses!",
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
          timer: 2000,
        });
        setTimeout(() => {
          window.location.href = "/admin/approvedByMrepo";
        }, 1000);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: "Diçka shkoi keq! Ju lutemi provoni përsëri.",
          timer: 2500,
          showConfirmButton: true,
          confirmButtonColor: "#18817d",
          confirmButtonText: "Mbyll",
        });
      })
      .finally(() => setIsSending(false)); // ✅ stop loading
  };

  return (
    <>
      <input type="checkbox" id="my-modal-7" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box w-11/12 max-w-5xl bg-white">
          <h3 className="flex justify-center pb-4 text-lg font-bold">
            Aprovimi i raportit nga Policia
          </h3>
          <hr />

          <select
            className="select-bordered select select-sm w-full bg-white mt-4"
            value={selectedLawId}
            onChange={(e) => {
              setSelectedLawId(e.target.value);
              setErrorMessage("");
            }}
            disabled={isSending} // ✅ disable dropdown while sending
          >
            <option value="" disabled>
              Zgjidh një ligj për të aprovuar raportin:
            </option>
            {laws.map((law) => (
              <option key={law.id} value={law.id}>
                {law.name}
              </option>
            ))}
          </select>

          {errorMessage && (
            <div className="mt-2 text-sm text-red-500">{errorMessage}</div>
          )}

          <footer className="modal-action">
            <label
              htmlFor="my-modal-7"
              className="btn-sm btn-circle btn absolute right-2 top-2"
            >
              ✕
            </label>
            <label
              htmlFor="my-modal-7"
              className={`btn border-0 bg-white text-brand-700 hover:text-white ${
                isSending ? "pointer-events-none opacity-50" : ""
              }`}
            >
              Kthehu
            </label>
            <button
              onClick={send}
              disabled={isSending} // ✅ disable button while sending
              className={`btn border-0 text-white ${
                isSending
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-brand-500 hover:bg-brand-700"
              }`}
            >
              {isSending ? "Duke dërguar..." : "Dërgo"}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default ApproveFromPolice;
